const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    wrapper: {
      extend: theme.wrapper,
      width: '100%',
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      overflow: 'hidden',
    },
    textBlock: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '21.8%',
      '& > *:not(:last-child)': {
        marginBottom: 30,
      },
    },
    pretitle: {
      width: '100%',
      textTransform: 'uppercase',
      color: theme.colors[3],
      fontSize: 10,
      borderTop: `1px solid ${theme.colors[3]}`,
      paddingTop: 10,
      '&::before': {
        content: '""',
        width: 8,
        height: 8,
        display: 'inline-block',
        background: theme.colors[3],
        marginRight: 8,
        borderRadius: '50%',
      },
    },
    title: {
      hyphens: 'auto',
      width: '100%',
      color: theme.colors[3],
      lineHeight: 1,
      fontSize: 39,
    },
    text: {
      width: '100%',
      color: theme.colors[5],
      fontSize: 16,
    },
    cardList: {
      position: 'relative',
      flexBasis: '71.8%',
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 10,
    },
    cardListFull: {
      flex: 1,
    },
    cardListTrack: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    card: {
      width: '30%',
      overflow: 'hidden',
      borderRadius: 16,
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      display: 'flex',
      flexDirection: 'column',
      '-webkit-backface-visibility': 'hidden',
      '-moz-backface-visibility': 'hidden',
      '-webkit-transform': 'translate3d(0, 0, 0)',
      '-moz-transform': 'translate3d(0, 0, 0)',
    },
    cardImage: {
      width: '100%',
      paddingBottom: '120%',
      overflow: 'hidden',
      position: 'relative',
    },
    cardInfo: {
      padding: '25px',
      display: 'flex',
      flexDirection: 'column',
    },
    cardCategory: {
      fontSize: 10,
      textTransform: 'uppercase',
      color: theme.colors[1],
      fontWeight: 'bold',
      letterSpacing: 1,
      marginBottom: 20,
    },
    cardTitle: {
      fontSize: 16,
      lineHeight: 1,
      marginBottom: 10,
    },
    cardText: {
      color: theme.colors[5],
      fontSize: 13,
    },
    rootLight: {
      '& $card': {
        backgroundColor: theme.colors[1],
      },
      '& $cardTitle': {
        color: theme.colors[0],
      },
      '& $cardCategory': {
        color: theme.colors[0],
      },
    },
    rootDark: {
      '& $card': {
        backgroundColor: theme.colors[0],
      },
      '& $cardTitle': {
        color: theme.colors[1],
      },
    },
    rootOrange: {
      backgroundColor: theme.colors[3],
      '& $card': {
        backgroundColor: theme.colors[0],
      },
      '& $cardTitle': {
        color: theme.colors[1],
      },
      '& $title': {
        color: theme.colors[1],
      },
      '& $text': {
        color: theme.colors[1],
      },
      '& $pretitle': {
        color: theme.colors[1],
        borderTop: `1px solid ${theme.colors[1]}`,
        '&::before': {
          background: theme.colors[1],
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    textBlock: {
      width: '35%',
    },
    cardList: {
      width: '55%',
      overflowX: 'scroll',
      scrollBehavior: 'smooth',
    },
    card: {
      flex: '0 0 280px',
    },
    cardListTrack: {
      display: 'flex',
      flexWrap: 'nowrap',
      '& > *:not(:last-child)': {
        marginRight: 30,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    container: {
      flexDirection: 'column',
    },
    textBlock: {
      width: '100%',
    },
    cardList: {
      width: '100%',
      marginTop: 40,
    },
    card: {
      flex: '0 0 250px',
    },
  }

  return output
}
export default style
